import React, { PropsWithChildren, useContext } from 'react'
import { Controller } from 'react-hook-form'
import UploadFile from '../../upload-file-v2/components/UploadFile'
import { FieldContext } from '../constants'
import { FieldInputControllerProps } from '../types/Field.types'
import { FieldInput } from './FieldInput'

export const FieldUploadFileController: React.FC<PropsWithChildren<FieldInputControllerProps>> = ({
  controller,
  errors,
  children
}) => {
  const { isRequired, name, error, helperText, ...otherProps } = useContext(FieldContext)

  return (
    <Controller
      name={name || ''}
      control={controller}
      render={({ field: { name, onChange, ...rest }, fieldState }) => {
        const fieldError = fieldState.invalid
        const fieldHelperText = errors && errors[name]?.message
        const isMultiple = React.isValidElement(children) ? children.props.multiple : false

        const handleChangeSingle = (files: string) => {
          onChange(isMultiple ? files : files?.[0] || null)
        }

        return (
          <FieldInput fieldError={fieldError} fieldHelperText={fieldHelperText} onChange={handleChangeSingle} {...rest}>
            {React.cloneElement(children as React.ReactElement<typeof UploadFile>)}
          </FieldInput>
        )
      }}
    />
  )
}
